import React from "react";
import { default as MuiCollapse } from "@mui/material/Collapse";

function Collapse(props) {
  return <MuiCollapse {...props} />;
}

export default Collapse;
